import { HsBufferType } from './enums/buffer-type.enum';
import type { HsGraphicsBuffer } from './types/graphic-buffer.type';

/**
 * Handles s graphics.
 */
export class HsGraphics {
  public gl: WebGL2RenderingContext;

  constructor(gl: WebGL2RenderingContext) {
    this.gl = gl;
  }

  public createBuffer(
    arrayBuffer: BufferSource,
    type: HsBufferType = HsBufferType.arrayBuffer
  ): HsGraphicsBuffer | null {
    const glBuffer: HsGraphicsBuffer | null = this.gl.createBuffer();

    if (glBuffer === null) {
      this.sendOutputErrorMessage('unable to create WebGLBuffer');
      return null;
    }

    this.gl.bindBuffer(this.gl[type], glBuffer);
    this.gl.bufferData(this.gl[type], arrayBuffer, this.gl.STATIC_DRAW);
    this.gl.bindBuffer(this.gl[type], null);

    return glBuffer;
  }

  public deleteBuffer(graphicsBuffer: HsGraphicsBuffer | null): void {
    this.gl.deleteBuffer(graphicsBuffer);
  }

  /**
   */
  private sendOutputErrorMessage(_errorMessage: string): void {
    return;
  }
}
